import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import { withStyles } from 'material-ui/styles';
import PanelHeader from '../parts/PanelHeader';
import StatusList from '../lists/StatusList';
import StatusOverview from '../parts/StatusOverview';
import ListLabel from '../parts/ListLabel';
import AddressList from '../lists/AddressList';
import Pagination from "../../common/Pagination";
import moment from 'moment';
import PlanDialog from '../../SendLetter/dialogs/PlanDialog';
import DemoDialog from '../dialogs/DemoDialog';
import TermRangeDialog from '../../common/TermRangeDialog';
import { DASHBOARD_PER_PAGE } from '../../../constants/Constants';
import { TimelineLabelType, DashboardTimelineType, DashboardStatusSortType, DateRanges, OwnerType } from '../../../constants/ComponentTypes';

const styles = () => ({
  root: {
    background: "#FAFAFA",
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  main: {
    marginTop: '44px',
    width: '80%',
    padding: '22px 25px 32px 25px',
    background: '#FFFFFF',
    boxShadow: '0px 1px 2px #0000001F',
    borderRadius: '4px',
    boxSizing: 'border-box',
  },

  title: {
    fontSize: '16px',
    color: '#181819',
    fontWeight: 'bold',
    paddingBottom: '9px',
    borderBottom: '1px solid #E7E9EB',
    marginBottom: '28px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },

  paginationContainer: {
    marginTop: '30px',
  }
});

class PageContentPanel extends React.Component {
  state = {
    showPlanDialog: false,
    showDemoDialog: false,
    showTermRangeDialog: false,
    dateSelected: DateRanges.PAST_1_YEAR,
    statusSelected: TimelineLabelType.APPROACH,
    sortType: DashboardStatusSortType.SORT_TYPE_STATED_AT_DESC.value,
    filterValue: {
      created_at_from: DateRanges.PAST_1_YEAR.from,
      created_at_to: DateRanges.PAST_1_YEAR.to,
      keyword: "",
    }
  }

  componentDidMount() {
    const { location } = this.props;
    // 条件に応じてstateを更新し、props.getStatusを実行する
    let state = {};
    let filterValue = {};
    if (location && location.state) {
      if (location.state.statusSelected && location.state.statusSelected !== this.state.statusSelected) {
        state.statusSelected = location.state.statusSelected;
      }
      if ((location.state.dateSelectedValue || location.state.dateSelectedValue === 0) && location.state.dateSelectedValue !== this.state.dateSelected.value) {
        state.dateSelected = Object.values(DateRanges).find(range => range.value === location.state.dateSelectedValue);
        filterValue.created_at_from = state.dateSelected.from;
        filterValue.created_at_to = state.dateSelected.to;
        state.filterValue = filterValue;
      }
      if (location.state.keyword && location.state.keyword !== this.state.filterValue.keyword) {
        filterValue.keyword = location.state.keyword;
        state.filterValue = filterValue;
      }
      if (location.state.sortType && location.state.sortType !== this.state.sortType) {
        state.sortType = location.state.sortType;
      }
    }

    if (state) {
      this.setState(state, () => {
        const defaultQuery = this.defaultValueToQuery();
        const query = this.filterValueToQuery(this.state.filterValue);
        this.props.getStatus({
          ...defaultQuery,
          ...query,
        }, true);
      });
    } else {
      const defaultQuery = this.defaultValueToQuery();
      const query = this.filterValueToQuery(this.state.filterValue)
      this.props.getStatus({
        ...defaultQuery,
        ...query,
      }, true);
    }
  }

  handleSortTypeChange = (sortType) => {
    this.setState({
      sortType: sortType
    }, () => {
      let defaultQuery = this.defaultValueToQuery();
      let query = this.filterValueToQuery(this.state.filterValue);
      this.props.getStatus({
        ...defaultQuery,
        ...query
      }, true);
    });
  }

  togglePlanDialog = () => {
    this.setState({
      showPlanDialog: !this.state.showPlanDialog,
      showDemoDialog: false,
    });
  }

  toggleDemoDialog = () => {
    this.setState({
      showDemoDialog: !this.state.showDemoDialog,
      showPlanDialog: false,
    });
  }

  handleSelectDate = (item) => {
    let filterValue = {
      created_at_from: item.from ? item.from : null,
      created_at_to: item.to ? item.to : null,
    };

    this.setState({
      dateSelected: item,
      filterValue: { ...this.state.filterValue, ...filterValue },
    }, () => {
      let defaultQuery = this.defaultValueToQuery();
      let query = this.filterValueToQuery(this.state.filterValue);
      this.props.getStatus({
        ...defaultQuery,
        ...query
      }, true);
    });
  }

  handleStatusClick = (item) => {
    this.setState({
      statusSelected: item
    }, () => {
      let defaultQuery = this.defaultValueToQuery();
      let query = this.filterValueToQuery(this.state.filterValue);
      this.props.getStatus({
        ...defaultQuery,
        ...query,
      }, true);
    });
  }

  handleChangeKeyword = (event) => {
    this.setState({
      filterValue: { ...this.state.filterValue, keyword: event.target.value },
    });
  }

  handleSearch = () => {
    let defaultQuery = this.defaultValueToQuery();
    let query = this.filterValueToQuery(this.state.filterValue);
    this.props.getStatus({
      ...defaultQuery, ...query }, true);
  }

  defaultValueToQuery = () => {
    const { type } = this.props;

    const variableQuery = {};
    if (type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) {
      variableQuery['selected_status'] = this.state.statusSelected.value;
      variableQuery['with_address_data'] = 0; // ステータス別の場合は全てのaddress_dataは不要なので0にする。actionsで選択したステータスのみwith_address_dataを1にしている。
    } else {
      variableQuery['with_address_data'] = 1;
    }

    if (
      type !== DashboardTimelineType.QR_CODE_REACTION.value ||
      type !== DashboardTimelineType.LEAD_NOTE.value ||
      type !== DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value
    ) {
      const target = Object.values(DashboardTimelineType).find(item => item.value === type);
      variableQuery['timeline_status'] = target.combination;
    }

    if (this.state.filterValue.keyword) {
      variableQuery['keyword'] = this.state.filterValue.keyword;
    }

    return {
      ...variableQuery,
      paging: 1,
      per_page: DASHBOARD_PER_PAGE,
      page: 1,
      include_corporation_count: 1,
      is_own: this.props.ownerType === OwnerType.OWN.value ? 'true' : 'false',
    }
  }

  filterValueToQuery = (filterValue = this.state.filterValue, withSortType = true) => {
    let data = {};
    for (let property in filterValue) {
      if (property === 'created_at_from' || property === 'created_at_to') {
        data[property] = filterValue[property] ? filterValue[property].format('YYYY-MM-DD') : null;
      } else {
        data[property] = filterValue[property];
      }
    }

    if (withSortType) {
      data['sort_type'] = this.state.sortType;
    }

    return data;
  }

  convertStatusLabelType = () => {
    // TODO ややこしいので直す
    const { type } = this.props;
    if (type === DashboardTimelineType.QR_CODE_REACTION.value) {
      return TimelineLabelType.QR_CODE_REACTION.value;
    } else if (type === DashboardTimelineType.LEAD_NOTE.value) {
      return "lead_note"
    } else if (type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) {
      return null
    } else {
      // TODO ややこしいので直す
      const target = Object.values(DashboardTimelineType).find(item => item.value === type);
      return target.combination[0];
    }
  }

  renderPlanDialog = () => (
    this.state.showPlanDialog && (
      <PlanDialog
        isOpen={this.state.showPlanDialog}
        toggleDialog={this.togglePlanDialog}
      />
    )
  );

  renderDemoDialog = () => (
    this.state.showDemoDialog && (
      <DemoDialog
        isOpen={this.state.showDemoDialog}
        toggleDialog={this.toggleDemoDialog}
        togglePlanDialog={this.togglePlanDialog}
        user={this.props.user}
      />
    )
  );

  renderTermRangeDialog = () => (
    this.state.showTermRangeDialog && (
      <TermRangeDialog
        isOpen={this.state.showTermRangeDialog}
        toggleDialog={this.toggleTermRangeDialog}
        startDate={this.state.filterValue.created_at_from ? this.state.filterValue.created_at_from.toDate() : moment().toDate()}
        endDate={this.state.filterValue.created_at_to ? this.state.filterValue.created_at_to.toDate() : moment().toDate()}
      />
    )
  );

  render() {
    const { classes, type, pageInfo } = this.props;
    let title;
    const target = Object.values(DashboardTimelineType).find(label => label.value === type);
    if (target) {
      title = target.text;
    }

    const isLoading = this.props.isLoading || (type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value && !pageInfo[this.state.statusSelected.value]);

    return (
      <div className={classes.root}>
        <div className={classes.main}>
          <PanelHeader
            title={title}
            type={this.convertStatusLabelType()}
            dateRanges={DateRanges}
            keyword={this.state.filterValue.keyword}
            handleChangeKeyword={this.handleChangeKeyword}
            handleSearch={this.handleSearch}
            dateSelected={this.state.dateSelected}
            handleSelectDate={this.handleSelectDate}
            togglePlanDialog={this.togglePlanDialog}
          />

          {type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value ?
            <StatusList
              pageInfo={this.props.pageInfo}
              handleClick={this.handleStatusClick}
              hasKLFollowCallBeenEnabled={this.props.hasKLFollowCallBeenEnabled}
              statusSelected={this.state.statusSelected.value}
            /> :
            <StatusOverview type={type} isLoading={isLoading} pageInfo={pageInfo} />
          }
          <ListLabel
            title={"送付先"}
            sortType={this.state.sortType}
            sortTypes={DashboardStatusSortType}
            handleSortTypeChange={this.handleSortTypeChange}
          />
          <AddressList
            items={(this.props.items && type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) ? this.props.items[this.state.statusSelected.value] : this.props.items}
            goTo={this.props.goTo}
            isLoading={isLoading}
            statusSelected={this.state.statusSelected}
            dateSelected={this.state.dateSelected}
            ownerType={this.props.ownerType}
            keyword={this.state.filterValue.keyword}
          />
        </div>
        {!isLoading &&
          pageInfo &&
          (pageInfo.hasOwnProperty('current_page') || (pageInfo[this.state.statusSelected.value] && pageInfo[this.state.statusSelected.value].hasOwnProperty("current_page"))) && (
            <div className={classes.paginationContainer}>
              <Pagination
                currentPage={(type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) ? pageInfo[this.state.statusSelected.value].current_page : pageInfo.current_page}
                lastPage={(type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) ? pageInfo[this.state.statusSelected.value].last_page : pageInfo.last_page}
                total={(type === DashboardTimelineType.BY_FOLLOW_CALL_STATUS.value) ? pageInfo[this.state.statusSelected.value].total : pageInfo.total}
                perPage={DASHBOARD_PER_PAGE}
                showLastPage={true}
                disabled={isLoading}
                onChange={(data) => {
                  let defaultQuery = this.defaultValueToQuery();
                  let query = this.filterValueToQuery(this.state.filterValue)
                  this.props.getStatus({ ...defaultQuery, ...query, ...data }, true)
                }}
              />
            </div>
          )}
        {this.renderPlanDialog()}
        {this.renderDemoDialog()}
        {this.renderTermRangeDialog()}
      </div>
    )
  }
}

PageContentPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number.isRequired,
  goTo: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  pageInfo: PropTypes.object,
  ownerType: PropTypes.string.isRequired,
  getStatus: PropTypes.func.isRequired,
  hasKLFollowCallBeenEnabled: PropTypes.bool,
  user: PropTypes.object,
  location: PropTypes.object,
};

PageContentPanel.defaultProps = {
  hasKLFollowCallBeenEnabled: false,
  isLoading: true,
};

export default withRouter(withStyles(styles)(PageContentPanel));



// WEBPACK FOOTER //
// ./src/components/OrderDashboardPages/panels/PageContentPanel.jsx